import TableHeader from './table-header';

export default TableHeader;
